import { useSpaPageAnalytics } from '../../hooks/useSpaPageAnalytics';

/** GA4 計測（全ルート）。App の認証ローディングより外で常時稼働。 */
export function SpaPageAnalytics() {
  useSpaPageAnalytics();
  return null;
}
